module.exports = __webpack_public_path__ + "static/media/block-5-ipswich.37e4d7a9.png";